import { render, staticRenderFns } from "./examDetail.vue?vue&type=template&id=323bee5a&scoped=true"
import script from "./examDetail.vue?vue&type=script&lang=js"
export * from "./examDetail.vue?vue&type=script&lang=js"
import style0 from "./examDetail.vue?vue&type=style&index=0&id=323bee5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323bee5a",
  null
  
)

export default component.exports